import { useEffect } from 'react';
import {
  EditButton,
  NumberField,
  SimpleShowLayout,
  TextField,
  UpdateButton,
  useGetIdentity,
  useRecordContext,
} from 'react-admin';

export const FrameworksCommandPanel = () => {
  const record = useRecordContext();

  useEffect(() => {
    console.log('record', record);
  }, [record]);

  const userId = useGetIdentity().data?.id?.toString();

  const now = new Date();

  return (
    <SimpleShowLayout record={record}>
      <TextField source="name" />
      <NumberField source="sortOrder" />
      <EditButton />
      <UpdateButton
        label={record.deletedAt ? 'Enable' : 'Disable'}
        color={record.deletedAt ? 'success' : 'error'}
        variant={record.deletedAt ? 'contained' : 'outlined'}
        mutationMode="pessimistic"
        confirmTitle="Are you sure?"
        confirmContent={
          record.deletedAt
            ? 'Activate this Framework?'
            : 'Deactivate this Framework?'
        }
        icon={null as any}
        data={{
          deletedAt: record.deletedAt ? null : now,
          deletedBy: userId,
          lastUpdatedAt: now,
          lastUpdatedBy: userId,
        }}
      />
    </SimpleShowLayout>
  );
};
